// subtasks/components/SubTaskStatusButtons.tsx
import React from "react";
import SubTaskStatusButtonsView from "./components/SubTaskStatusButtonsView";
import { UseSubTaskStatusButtonsProps, useSubTaskStatusButtonsController } from "./hooks/useSubTaskStatusButtonsController";

export default function SubTaskStatusButtons(props: UseSubTaskStatusButtonsProps) {
    // Always maintain consistent component structure to avoid React warnings
    if (!props.step || props.step.id == null) {
        return <></>;
    }
    const vm = useSubTaskStatusButtonsController(props);
    return <SubTaskStatusButtonsView {...vm} />;
}
